const TransfersAndHostingTableStatusesEnum = {
    AWAITING: 'Awaiting',
    PAID: 'Paid',
    APPROVED: "Approved",
    REJECTED: 'Rejected',
    CANCELED: "Canceled",
    EXPIRED: "Expired"
}
export default TransfersAndHostingTableStatusesEnum;
